export default __webpack_public_path__ + "static/media/trr-food-worb_chicken.470d0378.png";